export default __webpack_public_path__ + "media/images/22-d0eba3c09d9ea6efe37787e4a5a7e9e7.jpg";